import React from "react"
import FieldProto_FormElement from "../../../proto/render/form-element"

// @ts-ignore
import FieldString_RenderEditableInlineInput from './inline-editable/input-editable-inline'

export default class FieldString_FormElement extends FieldProto_FormElement {

    render() {
        //same classes for view and edit
        const classes: string = Classes("ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10", this.props.className)

        return <FieldString_RenderEditableInlineInput ref               = {this.ref}
                                                      viewClasses       = {classes}
                                                      editClasses       = {classes}
                                                      field             = {this.props.field}
                                                      value             = {this.value}
                                                      disabled          = {this.props.disabled}
                                                      // onChange          = {this.onChange}
                                                      onImmediateChange = {this.onChange}
                                                      onEnter           = {this.props.onEnter}/>
    }

}